import { render, staticRenderFns } from "./ContentSelection.vue?vue&type=template&id=a32bd0bc&scoped=true&"
import script from "./ContentSelection.vue?vue&type=script&lang=js&"
export * from "./ContentSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32bd0bc",
  null
  
)

export default component.exports